import React from 'react';
import { RetirementCalculatorBasicDataStepPropsModel } from '../../tools/RetirementCalculator.model';
import { RetirementCalculatorForm } from '../RetirementCalculatorForm/RetirementCalculatorForm';
import { RetirementCalculatorPreview } from '../RetirementCalculatorPreview/RetirementCalculatorPreview';
import { RetirementCalculatorLayout } from '../RetirementCalculatorLayout/RetirementCalculatorLayout';
import { useRetirementCalculatorLayout } from '../RetirementCalculatorLayout/RetirementCalculatorLayout.context';

import useLayoutStyles from '../RetirementCalculatorLayout/RetirementCalculatorLayout.style';

export const RetirementCalculatorBasicDataStep: React.FC<RetirementCalculatorBasicDataStepPropsModel> = ({
  title,
  submitLabel,
  salaryTooltip,
  initialValues,
  onSubmit,
  disabled,
  isLoading,
}) => {
  const c = useLayoutStyles({});
  const { titleId } = useRetirementCalculatorLayout();

  return (
    <RetirementCalculatorLayout>
      <RetirementCalculatorForm
        className={c.formColumn}
        titleId={titleId}
        title={title}
        submitLabel={submitLabel}
        salaryTooltip={salaryTooltip}
        initialValues={initialValues}
        onSubmit={onSubmit}
        disabled={disabled}
        isLoading={isLoading}
      />
      <RetirementCalculatorPreview className={c.previewColumn} />
    </RetirementCalculatorLayout>
  );
};
